import { render, staticRenderFns } from "./AssignLicenseLearners.vue?vue&type=template&id=8bacab86&scoped=true&"
import script from "./AssignLicenseLearners.vue?vue&type=script&lang=js&"
export * from "./AssignLicenseLearners.vue?vue&type=script&lang=js&"
import style0 from "./AssignLicenseLearners.vue?vue&type=style&index=0&id=8bacab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bacab86",
  null
  
)

export default component.exports